// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA9AGthe1x0o6lOi0_HOuy_DjFaEuVzh8M",
  authDomain: "ema-john-shopinng.firebaseapp.com",
  projectId: "ema-john-shopinng",
  storageBucket: "ema-john-shopinng.appspot.com",
  messagingSenderId: "538732810480",
  appId: "1:538732810480:web:c8ac38cb9b379daf967235"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;